module.exports = __webpack_public_path__ + "static/img/red.f52d59b4.gif";